import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import { SaveResult } from '../../../../shared/models/types'
import { HouseConsignmentDetails } from '../models/types'
import { toHouseConsignmentCreate, toHouseConsignmentUpdate } from '../models/mapper'
import { createHouseConsignment } from '../api/createHouseConsignment'
import { createHouseConsignmentDraft } from '../api/createHouseConsignmentDraft'
import { updateHouseConsignment } from '../api/updateHouseConsignment'
import { updateHouseConsignmentDraft } from '../api/updateHouseConsignmentDraft'

interface SaveHouseConsignmentParameters {
  id: number | null
  isDraft: boolean
  consignmentId: number
  formValues: HouseConsignmentFormValues
  consignorId: number | null
  consigneeId: number | null
  sellerId: number | null
  buyerId: number | null
}
function useSaveHouseConsignment() {
  const saveHouseConsignment = async ({
    id,
    isDraft,
    consignmentId,
    formValues,
    consignorId,
    consigneeId,
    sellerId,
    buyerId,
  } : SaveHouseConsignmentParameters): Promise<SaveResult<HouseConsignmentDetails>> => {
    try {
      let result: HouseConsignmentDetails
      if (id != null) {
        const data = toHouseConsignmentUpdate(id, formValues, consignorId, consigneeId, sellerId, buyerId)

        result = isDraft ? await updateHouseConsignmentDraft(id, data) : await updateHouseConsignment(id, data)
      } else {
        const data = toHouseConsignmentCreate(consignmentId, formValues, consignorId, consigneeId, sellerId, buyerId)

        result = isDraft ? await createHouseConsignmentDraft(data) : await createHouseConsignment(data)
      }

      return {
        data: result,
        errors: [],
      }
    } catch (e) {
      console.error('error', e)
      return {
        data: null,
        errors: [{ message: 'Error occurred when saving house consignment' }],
      }
    }
  }

  return {
    saveHouseConsignment,
  }
}

export default useSaveHouseConsignment
